import LabeledInputV2 from './LabeledInputV2'

export type { LabeledInputV2Props } from './LabeledInputV2'
export default LabeledInputV2
